
/**
 * Import CSS file for this component and its children
 */
// import demoStyles from "../../css/demo.css";

export default {
    name: 'ResultsBoxHeader',

    components: {
        
    },

    setup() {

    },

    template: /*html*/`
        <div class="cfm_results_box_header">
            State total, Issue 1 on constitutional amendments
        </div>
    `,
}